<template>
  <v-app>
    <router-view />
  </v-app>
  
</template>

<script>
import { mapState, mapActions } from "vuex";
import Navbar from "./components/Navbar.vue";
import Home from "./components/Home.vue";
import SignUp from "./components/SignUp.vue";
import SignIn from "./components/SignIn.vue";
import PasswordEntry from "./components/PasswordEntry.vue";
import ConfirmSignupView from "./components/ConfirmSignupView.vue";
import ForgotPassword from "./components/ForgotPassword.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Home,
    SignUp,
    SignIn,
    PasswordEntry,
    ConfirmSignupView,
    ForgotPassword,
  },
  data() {
    return {
      screen: "home", // Possible values: 'home', 'signup', 'passwordEntry', 'confirmSignup'
      form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        country: "USA",
        state: "",
        city: "",
        address1: "",
        address2: "",
        zip: "",
        phone: "",
        dateOfBirth: "",
        password: "",
        verifyPassword: "",
      },
      states: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      passwordsMatch: true,
    };
  },
  computed: {
    ...mapState(["isAuthenticated"]),
  },
  methods: {
    ...mapActions(["login"]),
    ...mapActions(["logout"]),
    showSignUp() {
      this.screen = "signup";
    },
    showSignIn() {
      this.screen = "signin";
    },
    showHome() {
      this.screen = "home";
    },
    showPasswordEntry() {
      this.screen = "passwordEntry";
    },
    showForgotPassword() {
      console.log("forgotPassword");
      this.screen = "forgotPassword";
    },
    showConfirmSignup() {
      this.screen = "confirmSignup";
    },
    checkPasswordsMatch() {
      this.passwordsMatch = this.form.password === this.form.verifyPassword;
    },
  },
};
</script>
